var render, staticRenderFns
import script from "./mm-icon.vue?vue&type=script&lang=js&"
export * from "./mm-icon.vue?vue&type=script&lang=js&"
import style0 from "./mm-icon.vue?vue&type=style&index=0&id=514f7efa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_z2a3irye3y56jaq776fqxbsiea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports